
import { POST } from "../../APiHelper/API";

export const repopulatePositionsAPI = (team_id, onSuccess, onError) => {
    const data = {}
    POST(`/api/v1/leagues/team/${team_id}/repopulate_positions`, data, onSuccess, onError)
}